import React, { useEffect, useState } from 'react'

// Self-contained copy of Carrier's UserControl.
// Removed: jquery import (unused), react-awesome-reveal animations.
const UserControl = ({ shipment, pickupOrDelivery }) => {
    const [consolidationShipment, setConsolidationShipment] = useState(null)
    const [allUserControls, setAllUserControls] = useState([])
    const [state, setState] = useState('start')

    useEffect(() => {
        if (shipment?.details?.trip) {
            fetchShipmentDetails(shipment.details.trip)
        }
    }, [shipment]) // eslint-disable-line react-hooks/exhaustive-deps

    const fetchShipmentDetails = async (webquotecontrol) => {
        setState('loading')
        try {
            const res = await fetch(
                `https://api.shippersedge.com/v4/shipment/${webquotecontrol}/?include=stopDetails`,
                { headers: { 'x-api-key': 'vdhy8wwjUJrwhxFpfuECTiAW' } }
            )
            const data = await res.json()
            setState('success')
            setConsolidationShipment(data)
        } catch {
            setState('error')
        }
    }

    useEffect(() => {
        if (consolidationShipment && pickupOrDelivery) {
            const stop = findStop(shipment.id, pickupOrDelivery, consolidationShipment)
            if (stop) {
                setAllUserControls(stop.orders.map(o => o.usercontrol))
            }
        }
    }, [consolidationShipment, pickupOrDelivery, shipment]) // eslint-disable-line react-hooks/exhaustive-deps

    const findStop = (shipmentId, type, cs) => {
        const validStops = cs.stops.filter(s => s.type === type)
        for (const stop of validStops) {
            for (const order of stop.orders) {
                if (parseInt(order.id) === shipmentId) return stop
            }
        }
        return null
    }

    if (!shipment || !pickupOrDelivery) return null

    if (state === 'loading') {
        return <div className="spinner-border spinner-border-sm text-primary my-2" role="status" />
    }

    if (state === 'error' && shipment.details?.trip) {
        return (
            <span
                className="badge bg-danger ms-1"
                style={{ cursor: 'pointer' }}
                onClick={() => fetchShipmentDetails(shipment.details.trip)}
                title="Click to retry"
            >
                Error loading — retry
            </span>
        )
    }

    if (!consolidationShipment) {
        return <span className="ms-1">{shipment.usercontrol}</span>
    }

    return (
        <div>
            {allUserControls.map((uc, i) => (
                <div key={i} className="ms-1">{uc}</div>
            ))}
        </div>
    )
}

export default UserControl
